import { cn } from '@utils/cn';
import type { RichtextStoryblok } from '@utils/storyblok/storyblok';
import CheckSvg from '@vectors/check.svg';
import { RichText } from '@common/typography/RichText';

type FormSuccessProps = {
  successText?: RichtextStoryblok;
};

export function FormSuccess({ successText }: FormSuccessProps) {
  return (
    <div className="flex flex-col space-y-3">
      <div
        className={cn(
          'flex gap-3 p-4 my-2 rounded-lg border',
          'border-green-300 bg-green-50',
          'text-green-800',
        )}
      >
        <CheckSvg className="h-6 w-6 text-green-400 shrink-0" />
        <div className="[&_.rich-text]:m-0">
          <RichText text={successText} />
        </div>
      </div>
    </div>
  );
}
